import instance from 'shared/helpers/axios';
import { catchError } from 'shared/helpers/catchError';
import { ITimezonesResponse } from './types';

export const getTimezones = async () => {
  try {
    const { data } = await instance.get<ITimezonesResponse>('/dictionaries/timezones');
    return data;
  } catch (error) {
    catchError(error);
  }
};
